<!--
<div class="dsb-card">
  <div class="dsb-card-header">
    <img mat-card-avatar *ngIf="isBank()" src="assets/images/bank.svg" alt="">
    <img mat-card-avatar *ngIf="isCard()" src="assets/images/card.svg" alt="">
    <img *ngIf="!fundingAccount.fundingSubtype" src="" alt="">
    <div>{{fundingAccount.institutionName}}</div>
  </div>

  <div class="dsb-card-content-container">
    <label class="dsb-card-label">ACCOUNT</label>
    <span class="dsb-card-value">{{ fundingAccount.maskedFundingAccount }}</span>

    <label class="dsb-card-label">TYPE</label>
    <span class="dsb-card-value">{{ fundingAccount.fundingSubtype }}</span>

    <label class="dsb-card-label">ACCOUNT NICKNAME</label>
    <span class="dsb-card-value">{{ fundingAccount.fundingAccountNickname ? fundingAccount.fundingAccountNickname : '' }}</span>
  </div>

  <div class="dsb-card-footer">
    <button type="button" class="dsb-btn" (click)="onEditFundingAccount(fundingAccount.tokenid)">
      Choose Funding Account
    </button>

    <button type="button"  class="dsb-btn" (click)="onDeleteFundingAccount(fundingAccount.tokenid)">
      Delete
    </button>
  </div>
</div>
-->

<div class="dsb-card-wrapper">
  <div class="dsb-card">
    <div class="dsb-card-header">
      <div>{{fundingAccountDescription}}</div>
      <img mat-card-avatar *ngIf="isBank()" src="assets/images/bank.svg" alt="">
      <img mat-card-avatar *ngIf="isCard()" src="assets/images/card.svg" alt="">
      <img *ngIf="!fundingAccount.fundingSubtype" src="" alt="">
    </div>
    {{varTest()}}

    <button (click)="resetVarTest()"> Reset varTest </button>

    <div class="small-dsb-card-item">Type: {{fundingAccount.fundingSubtype}}</div>
    <div class="small-dsb-card-item">Nickname: {{fundingAccount.fundingAccountNickname}}</div>
  </div>

  <div class="dsb-card-footer">
<!--     
    <button class="dsb-left-btn" type="button" (click)="onEditFundingAccount(fundingAccount)">
      <span>Edit&nbsp;&nbsp;</span><span><img style="margin-bottom: .2em;" src="assets/images/edit-pen.svg"/></span>
    </button>
 -->
    <button class="dsb-center-btn" type="button"  (click)="onDeleteFundingAccount(fundingAccount.tokenid)">
      <span>Delete&nbsp;&nbsp;</span><span><img style="margin-bottom:0.2em;height:.9rem;" src="assets/images/trash-can.svg"/></span>
    </button>
  </div>
</div>
